import React from 'react'
import { DebouncedTextFilter } from 'scenes/Dashboard/components/DebouncedTextFilter'

import { makeStyles } from 'tss-react/mui'

import { Theme } from '@mui/material'

import { cx } from 'tss-react/@emotion/css'

import { UserListViewFilters } from '../../scenes/UserListView/UserListViewStore'
import { UserRole } from '../../../../../../entities-next/user'
import { UserRoleSelector } from './UserRoleSelector.component'

export type UserFiltersProps = {
  className?: string
  filters: UserListViewFilters
  onChange: (filters: UserListViewFilters) => void
}

export function UserFilters({ className, filters, onChange }: UserFiltersProps) {
  const { classes } = useStyles()
  const handleEmailChange = (email: string) => {
    onChange({ ...filters, email })
  }
  const handleCorporateIdChange = (corporateId: string) => {
    onChange({ ...filters, corporateId: Number(corporateId) })
  }
  const handleNameChange = (name: string) => {
    onChange({ ...filters, name })
  }
  const handleRoleChange = (role: UserRole) => {
    onChange({ ...filters, role })
  }
  return (
    <div className={cx(className, classes.filterList)}>
      <DebouncedTextFilter defaultValue={filters.name} placeholder="Name..." onChange={handleNameChange} />
      <DebouncedTextFilter defaultValue={filters.email} placeholder="Email..." onChange={handleEmailChange} />
      <DebouncedTextFilter
        defaultValue={filters.corporateId?.toString()}
        placeholder="Corporate Id..."
        onChange={handleCorporateIdChange}
      />
      <UserRoleSelector role={filters.role} onChange={handleRoleChange} />
    </div>
  )
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  filterList: {
    display: 'flex',
    gap: spacing(2),
  },
}))
